import { Stack } from '@mui/material'
import { useAtomValue } from 'jotai'
import { memo } from 'react'
import { getOrderSide } from 'utils/order'
import { SpotMatchRecord } from '../../api/v1/spot'
import { useOrderValue } from '../../hooks/useSizeCalculations'
import { useSpotSymbols } from '../../store/spot/hooks'
import { OrderDirection } from '../../store/spot/types'
import { encryptionAddress } from '../../utils/address'
import { viewOnZKLinkExplorer } from '../../utils/explorer'
import { getEffectiveDecimals, toFixed } from '../../utils/number'
import { findSymbolByName } from '../../utils/symbols'
import { orderModalAtom, useUpdateModalTitle } from './index'
import { OrderModalRow, OrderModalRowInfo, OrderModalRowLabel } from './styles'
import { DateFormatter } from '../../utils/datetime'

export const SpotTradeHistoryModal = memo(() => {
  const orderData = useAtomValue(orderModalAtom)
  const spotSymbols = useSpotSymbols()

  const data = orderData?.data as SpotMatchRecord

  useUpdateModalTitle(data?.symbol)

  const {
    type = '',
    symbol: symbolName = '',
    direction = OrderDirection.LONG,
    matchQuantity = 0,
    matchPrice = 0,
    fee = 0,
    feeCurrency = '',
    txHash = '',
    orderId = 0,
    createdAt = 0,
  } = data

  const symbol = findSymbolByName(spotSymbols, symbolName)
  const {
    baseScale = 0,
    quoteScale = 0,
    baseCurrency = '',
    quoteCurrency = '',
  } = symbol

  const value = useOrderValue(matchQuantity, matchPrice)
  const fixedValue = toFixed(value, quoteScale)

  const fixedSize = toFixed(matchQuantity, baseScale)
  const fixedPrice = toFixed(matchPrice, quoteScale)

  const datetime = DateFormatter.toISODateTime(createdAt)
  return (
    <Stack>
      <OrderModalRow>
        <OrderModalRowLabel>
          <div>Size</div>
          <div>Price</div>
        </OrderModalRowLabel>
        <OrderModalRowInfo>
          <div className={getOrderSide(direction, 'lowerCase')}>
            {fixedSize} {baseCurrency}
          </div>
          <div>
            {fixedPrice} {quoteCurrency}
          </div>
        </OrderModalRowInfo>
      </OrderModalRow>
      <OrderModalRow>
        <OrderModalRowLabel>
          <div>Side</div>
          <div>Value</div>
        </OrderModalRowLabel>
        <OrderModalRowInfo>
          <div className={getOrderSide(direction, 'lowerCase')}>
            {getOrderSide(direction)}
          </div>
          <div>
            {fixedValue} {quoteCurrency}
          </div>
        </OrderModalRowInfo>
      </OrderModalRow>

      <OrderModalRow>
        <OrderModalRowLabel>
          <div>Type</div>
          <div>Fee</div>
        </OrderModalRowLabel>
        <OrderModalRowInfo>
          <div>{type}</div>
          <div>
            {getEffectiveDecimals(fee)} {feeCurrency}
          </div>
        </OrderModalRowInfo>
      </OrderModalRow>
      <OrderModalRow>
        <OrderModalRowLabel>
          <div>Order ID</div>
          <div>Time</div>
        </OrderModalRowLabel>
        <OrderModalRowInfo>
          <div>{orderId}</div>
          <div>{datetime}</div>
        </OrderModalRowInfo>
      </OrderModalRow>
      <OrderModalRow>
        <OrderModalRowLabel>
          <div>Txid</div>
        </OrderModalRowLabel>
        <OrderModalRowInfo>
          <div onClick={() => viewOnZKLinkExplorer(txHash)}>
            {encryptionAddress(txHash)}
          </div>
        </OrderModalRowInfo>
      </OrderModalRow>
    </Stack>
  )
})
